import React from 'react'
import { useParams, useLocation, useSearchParams } from 'react-router-dom'
import { useEntityNavigate as useNavigate } from '../../navigation/navigation'
import EntityForm from '../../components/EntityForm'
import { Button } from '../../components/ui'
import './Company.css'

function ObjectEdit() {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const isNew = location.pathname.endsWith('/new') || id === 'new'
  const editId = isNew ? null : id
  const clientId = location.state?.clientId ?? (searchParams.get('client_id') || undefined)
  const objectId = location.state?.objectId
  const context = { clientId: clientId || undefined, objectId: objectId || undefined }

  return (
    <div className="company-page">
      <div className="page-header">
        <Button variant="ghost" onClick={() => navigate(isNew ? '/company/objects' : `/object/${editId}`)} className="btn-back">
          ← Назад
        </Button>
      </div>
      <EntityForm
        entityType="objects"
        entityId={editId}
        context={context}
        title={isNew ? 'Новый объект' : 'Редактирование объекта'}
      />
    </div>
  )
}

export default ObjectEdit
